const s3Host = import.meta.env.VITE_S3_BUCKET_URL
const s3_Bucket = import.meta.env.VITE_S3_BUCKET

const CONFIG = {
  s3Host,
  s3_Bucket,
  apiHost: import.meta.env.PROD ? import.meta.env.VITE_API_HOST || '' : '',
  esbHost: import.meta.env.PROD ? import.meta.env.VITE_ESB_HOST || '' : '',
  iconFolder: s3Host + '/icon/',
  iconSvgFolder: s3Host + '/static/iconsvg/',
  equipmentImportTemplate: `${s3Host}/templates/RoundTemplate/NewEquipmentImportTemplate.xlsx`,
  vendorTemplate: `${s3Host}/templates/Vendor/VendorTemplate20240614.xlsx`,
  contactTemplate: `${s3Host}/templates/Contact/ContactTemplate.xlsx`,
  propertyImportTemplate: `${s3Host}/templates/Property/BuildingImportTemplate20240506.xlsx`,
  inspectionTemplate: `${s3Host}/templates/Inspection/InspectionImport.xlsx`,
  adminHost: import.meta.env.VITE_ADMIN_HOST,
  tenantTemplate: `${s3Host}/templates/Tenant/TenantTemplate.xlsx`,
  tenantContactTemplate: `${s3Host}/templates/Tenant/TenantContactTemplate.xlsx`,
  residentTemplate: `${s3Host}/templates/Tenant/ResidentTemplate.xlsx`,
  activateLogo: 'https://s3.amazonaws.com/activate.com/Activate-01-logo.png',
  activateTerms:
    'https://activate-dev-env.s3.us-east-2.amazonaws.com/static/resources/Activate+Terms+%26+Conditions.pdf',
  logo: `${''}/activate_logo_white.png`,
  logoSvg: `${''}/activate_logo.svg`,
  googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',
  logoIcon: `${''}/android-chrome-512x512.png`,
  tenancyScheduleTemplate:
    'https://activate-prod-env.s3.us-east-2.amazonaws.com/templates/Tenant/TenancyScheduleTemplate.xlsx',
}
export default CONFIG
